import {
  Component,
  Input,
  Output,
  OnInit,
  OnDestroy,
  ViewChild,
  EventEmitter,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PostTradeService } from '../../post-trade/post-trade.service';
import {
  SortDescriptor,
  State,
  CompositeFilterDescriptor,
} from '@progress/kendo-data-query';
import { CustomFiltersService } from '../../services/custom-filters.service';
import { Router } from '@angular/router';
import {
  FormControl,
  FormBuilder,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { DateTime } from 'luxon';
import { scoreClassKey } from '../../lib/shared-value-keys';
import { MatDialog } from '@angular/material/dialog';
import { AlertsDialogComponent } from '../../post-trade/components/alerts-dialog/alerts-dialog.component';
import {
  appCols,
  getFilterMenuText,
  bulkActionOptions,
  scoreIconDataFields,
  noColSaveGrids,
  noFilterSaveGrids,
  ptGrids,
  pageSizeOptions,
} from '../../lib/rb-grid-lib';
import {
  ColumnBase,
  FilterService,
  GridComponent,
  KENDO_GRID,
  RowClassArgs,
} from '@progress/kendo-angular-grid';
import { AdminService } from '../../admin/admin.service';
import { CaseManagementService } from '../../case-management/case-management.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { BookManagementService } from '../../book-management/book-management.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location, CommonModule } from '@angular/common';
import { UniversalSearchService } from '../../universal-search/services/universal-search.service';
import { WarnDialogComponent } from '../../warn-dialog/warn-dialog.component';
import { RightBridgeApiService } from '../../services/right-bridge-api.service';
import { UnifiedFlowService } from '../../unified-flow/unified.service';
import isEmpty from 'lodash-es/isEmpty';
import isEqual from 'lodash-es/isEqual';
import cloneDeep from 'lodash-es/cloneDeep';
import every from 'lodash-es/every';
import some from 'lodash-es/some';
import { InvestmentWizardService } from '../../investment-wizard/services/investment-wizard-service.service';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { UserPreferencesService } from '../../services/user-preferences.service';
import { RbGridService } from './rb-grid.service';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { GridFiltersComponent } from '../grid-filters/grid-filters.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { GridColumnFilterComponent } from '../grid-column-filter/grid-column-filter.component';
import { FirmBenchmarkingComponent } from '../firm-benchmarking/firm-benchmarking.component';
import { KENDO_MULTISELECT } from '@progress/kendo-angular-dropdowns';
import { KENDO_TEXTBOX } from '@progress/kendo-angular-inputs';
import { DateRangeFilterComponent } from '../date-range-filter/date-range-filter.component';
import { AmountRangeFilterComponent } from '../amount-range-filter/amount-range-filter.component';
import { KENDO_PAGER } from '@progress/kendo-angular-pager';
import { SimpleLoadingComponent } from '../simple-loading/simple-loading.component';
import { NgxLoadingModule } from 'ngx-loading';
import { MatMenuModule } from '@angular/material/menu';
import { LocalTime } from '../../local-time.pipe';
import { FilterValuesPipe } from '../../filter-value.pipe';
import { CloneCaseComponent } from './components/clone-case/clone-case.component';
import { CopyCaseComponent } from './components/copy-case/copy-case.component';
import { DownloadGridReportComponent } from './components/download-grid-report/download-grid-report.component';
import { DecryptFieldComponent } from './components/decrypt-field/decrypt-field.component';
import { BulkActionsComponent } from './components/bulk-actions/bulk-actions.component';
import { AlertListDisplayComponent } from './components/alert-list-display/alert-list-display.component';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { LuanchAppButtonsComponent } from './components/launch-app-buttons/launch-app-buttons.component';
import { SubheadTableComponent } from './components/subhead-table/subhead-table.component';

@Component({
  selector: 'app-rb-grid',
  templateUrl: './rb-grid.component.html',
  styleUrls: ['./rb-grid.component.scss'],
  imports: [
    AlertListDisplayComponent,
    AmountRangeFilterComponent,
    BreadcrumbComponent,
    BulkActionsComponent,
    CommonModule,
    CloneCaseComponent,
    CopyCaseComponent,
    DateRangeFilterComponent,
    DecryptFieldComponent,
    DownloadGridReportComponent,
    FirmBenchmarkingComponent,
    FormsModule,
    GridColumnFilterComponent,
    GridFiltersComponent,
    KENDO_GRID,
    KENDO_MULTISELECT,
    KENDO_PAGER,
    KENDO_TEXTBOX,
    LocalTime,
    FilterValuesPipe,
    LuanchAppButtonsComponent,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatFormFieldModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatTooltipModule,
    NgxLoadingModule,
    ReactiveFormsModule,
    SimpleLoadingComponent,
    SubheadTableComponent,
  ],
  providers: [provideLuxonDateAdapter()],
})
export class RbGridComponent implements OnInit, OnDestroy {
  private cdRef = inject(ChangeDetectorRef);
  private cstmFltrSrvc = inject(CustomFiltersService);
  private route = inject(Router);
  private snacky = inject(MatSnackBar);
  private dbs = inject(DashboardService);
  private ss = inject(SessionStorageService);
  private prefSrvc = inject(UserPreferencesService);
  private gridSrvc = inject(RbGridService);
  adminService = inject(AdminService);
  ptSvc = inject(PostTradeService);
  cms = inject(CaseManagementService);
  bmSvc = inject(BookManagementService);
  usService = inject(UniversalSearchService);
  rbs = inject(RightBridgeApiService);
  unfFlowSvc = inject(UnifiedFlowService);
  iws = inject(InvestmentWizardService);
  fb = inject(FormBuilder);
  dialog = inject(MatDialog);
  location = inject(Location);

  @ViewChild('rbGrid', { static: false })
  public rbGrid: GridComponent;
  @ViewChild('pageSelector', { static: false })
  public pageSelector: MatCheckbox;
  @Input() gridConfig;
  @Input() getSetup;
  @Input() getData;
  @Output() deleteItem = new EventEmitter();
  @Output() selectedProfileIdOutput = new EventEmitter();
  selectedProfileId: any;
  lastFilter;
  clearFilterSort: boolean = false;
  colFiltersChanged: {
    reset?: boolean;
    values?: any;
    dataField?: any;
    filterData?: any;
    currentFilters?: CompositeFilterDescriptor;
  };
  allSolutionDisplay: boolean = false;
  loadedUserPrefs: boolean = false;
  hiddenExtCols: any = [];
  hiddenExtColsShowing: boolean = false;
  pageChangeData: { skip: number; take: number } | null;

  unsubscribe: Subject<any> = new Subject();
  loading = false;
  public hidden: string[] = [];
  public ogHidden: string[] = [];
  public pageSize = 25;
  public pageSizeOptions = pageSizeOptions;
  public skip = 0;
  public sort: SortDescriptor[] = [];
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  public getFilterMenuText = getFilterMenuText;
  ogData;
  gridData = {
    data: null,
    headers: null,
    subHead: [],
    total: 0,
  };
  state: State = {
    filter: this.filter,
    sort: this.sort,
    skip: this.skip,
    take: this.pageSize,
  };
  hideGrid = true;
  externalFilters = [];
  hierarchyFilters = [];
  dropdownFilters = [];
  searchFilters = [];
  equalSearchFilters = [];
  dateFilters = [];
  presetDateFilters = [];
  valueRangeFilters = [];
  filterOptions = {};
  ogFilterData = {};
  filterData = {};
  resetFilters = false;
  bulkActionOptions = bulkActionOptions;
  scoreIconDataFields = scoreIconDataFields;
  ptGrids = ptGrids;
  selectedTradeList = [];
  selectedChecked = {};
  pageSelectControl = false;
  pagesSelected = [];
  bulkSelectControl = false;
  bulkActionControl = new FormControl();
  scoreClassKey = scoreClassKey;
  bridgeIdSearch;
  dropdownOptions = {};
  defaultView: { filter: []; sort: [] } = { filter: [], sort: [] };
  defaultViewSet = false;
  groupBySelection = null;
  changedView = false;
  rights = [];
  showEmptyGridWarning = true;
  simpleLoading = false;
  reportDescription;
  selectedSolution;
  selectiveCopyCase: boolean = false;
  copyProfile: boolean = false;
  selectableSetting = null;
  canDelete: boolean = false;
  showSummaryLink = false;
  repBehaviorReport = null;
  reportFilters: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  benchmarkData = [];
  loadingBenchmarks = false;
  fileLoading: boolean = false;
  showPtDateWarning = false;
  gridOrderFields: string[] = [];

  ngOnInit(): void {
    if (this.gridConfig.defaultPageSize) {
      this.pageSize = this.gridConfig.defaultPageSize;
      this.state.take = this.gridConfig.defaultPageSize;
    }

    this.getGridSetup();

    this.rights = this.ss.get('rights');

    if (
      this.rights?.includes('CM') &&
      !this.bulkActionOptions.find(option => option.value === 'initiateCase')
    ) {
      this.bulkActionOptions.push({
        display: 'Initiate Case',
        value: 'initiateCase',
      });
    }

    if (
      this.ptGrids.includes(this.gridConfig.gridName) &&
      !this.bulkActionOptions.find(option => option.value === 'addNote')
    ) {
      this.bulkActionOptions.push({
        display: 'Add Note',
        value: 'addNote',
      });
    }

    this.selectiveCopyCase =
      this.rights?.includes('SelectiveCopyCase') &&
      this.ss.get('globals')?.GlobalsGroup?.UnitCopySettings
        ?.AllowSelectiveCopyOnSearch;

    this.copyProfile = this.rights?.includes('CopyProfile');

    this.canDelete = this.rights?.includes('DeleteProfile');

    if (this.gridConfig.gridName === 'RepBehavior') {
      this.cstmFltrSrvc.updateSolution$
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: solutionVal => {
            this.clearFilterSort = true;
            this.selectedSolution = solutionVal;
          },
          error: error => alert(error),
        });

      this.cstmFltrSrvc.updateRepReport$
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: reportVal => {
            const existingFilter = this.filter.filters.find(
              filter => filter['field'] === 'name'
            );
            this.clearFilterSort = true;
            this.reportDescription = this.repBehaviorReport?.find(
              report =>
                report.Module.toLowerCase() === this.selectedSolution &&
                report.ReportName === reportVal
            );

            if (existingFilter && existingFilter['value'] !== reportVal) {
              this.clearAdditionalFilters();
            }

            if (!reportVal && existingFilter) {
              this.filter.filters = this.filter.filters.filter(
                filter => filter['field'] !== 'name'
              );
              this.filter = JSON.parse(JSON.stringify(this.filter));
              this.updateFilters(this.filter);
            }
          },
          error: error => alert(error),
        });
    }

    if (this.gridConfig.gridName === 'CaseExplorer') {
      this.cstmFltrSrvc.updateSolution$
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: solutionVal => {
            this.clearFilterSort = true;
            this.selectedSolution = solutionVal;
          },
          error: error => alert(error),
        });
    }

    if (this.gridConfig.gridName === 'CopyCase') {
      this.pageSize = 10;
      this.state.take = this.pageSize;
      this.selectableSetting = { mode: 'single' };
    }

    this.cstmFltrSrvc.updateGroupBy$.subscribe((val: string) => {
      if (val) {
        this.groupBySelection = val;
      }
    });
  }

  ngOnDestroy() {
    this.gridSrvc.destroyGridSelections();
    this.bulkActionOptions = bulkActionOptions;
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  selectRow(ev) {
    if (
      this.gridConfig.gridName === 'CopyCase' &&
      this.gridConfig.profileId === ev.selectedRows[0].dataItem.profileId
    ) {
      // don't allow copy from the current case
      this.dialog.open(WarnDialogComponent, {
        panelClass: 'warn-dialog',
        data: {
          headline: 'Oops!',
          content: `You can't copy that case.`,
          confirm: 'Okay',
          hideCancel: true,
        },
      });
    } else {
      this.selectedProfileId = ev.selectedRows[0]?.dataItem.profileId;
      this.selectedProfileIdOutput.emit(this.selectedProfileId);
    }
  }

  getGridSetup(skipDefault = false, fillEmptyGrid = false, autoUpdate = false) {
    if (!skipDefault && this.gridConfig.gridName !== 'CopyCase') {
      this.hideGrid = true;
    }
    if (!fillEmptyGrid) {
      this.loading = true;
    } else if (fillEmptyGrid && this.gridConfig.simpleLoader) {
      this.simpleLoading = true;
      this.showEmptyGridWarning = false;
    }
    this.defaultViewSet = false;
    let setupParam;
    if (this.ss.get(`${this.gridConfig.gridName}Filters`)?.filters?.length) {
      this.filter = this.ss.get(`${this.gridConfig.gridName}Filters`);

      const groupFilter = this.filter.filters.find(
        filterItem => filterItem['field'] === 'group'
      );
      if (groupFilter) {
        this.groupBySelection = groupFilter['value'];
      }
    }
    const groupByVal = this.filter?.filters?.find(
      filterItem => filterItem['field'] === 'group'
    );
    if (groupByVal) {
      this.groupBySelection = groupByVal['value'];
    }
    if (this.gridConfig.initialProgram) {
      this.filter.filters = this.gridConfig.preselectedFilters?.FilterData
        ?.filters || [
        {
          field: 'ProgramName',
          operator: 'equal',
          value: this.gridConfig.initialProgram,
        },
      ];
    }
    if (this.gridConfig.groupByOptions) {
      if (!this.groupBySelection) {
        this.groupBySelection = this.gridConfig.groupByOptions[0].value;
        this.cstmFltrSrvc.updateGroupByValue(this.groupBySelection);
      }
      if (
        this.gridConfig.gridName === 'CaseManagement' &&
        this.groupBySelection &&
        this.groupBySelection === 'GROUP'
      ) {
        setupParam = 'cm-grid';
      } else if (
        this.gridConfig.gridName === 'CaseManagement' &&
        this.groupBySelection &&
        this.groupBySelection === 'FLAT'
      ) {
        setupParam = 'product-view';
      } else if (this.gridConfig.gridName === 'CaseExplorer') {
        if (this.groupBySelection === 'group') {
          setupParam = 'CaseSummaryStatsGrouped';
        } else if (this.groupBySelection === 'products') {
          setupParam = 'CaseSummaryStats';
        } else if (this.groupBySelection === 'review') {
          setupParam = 'CaseSummaryStatsFullReview';
        }
      } else if (this.gridConfig.gridName === 'RepBehavior') {
        if (this.groupBySelection && this.filter.filters.length) {
          if (this.groupBySelection === 'user') {
            setupParam = `${
              this.filter.filters.find(
                filterItem => filterItem['field'] === 'name'
              )['value']
            }-User`;
          } else if (this.groupBySelection === 'rep') {
            setupParam = `${
              this.filter.filters.find(
                filterItem => filterItem['field'] === 'name'
              )['value']
            }-Rep`;
          }
        }
      }
      if (this.clearFilterSort) {
        if (this.gridConfig.gridName === 'CaseExplorer') {
          this.filter.filters.forEach(filterItem => {
            if (filterItem['filters'] && Array.isArray(filterItem['filters'])) {
              const keepFilters = filterItem['filters'].filter(subFilter => {
                return (
                  subFilter.field === 'userName' ||
                  subFilter.field === 'clientName' ||
                  subFilter.field === 'unitName'
                );
              });
              filterItem['filters'] = keepFilters;
            }
          });
          if (this.sort.length > 0) {
            this.sort = this.sort.filter(
              sortItem =>
                sortItem.field === 'userName' ||
                sortItem.field === 'clientName' ||
                sortItem.field === 'unitName'
            );
          }

          this.setStorage();
          this.state = {
            filter: this.filter,
            sort: this.sort,
            skip: this.skip,
            take: this.pageSize,
          };
          this.clearFilterSort = false;
        } else {
          this.filter.filters = this.filter.filters.filter(filterItem => {
            if (filterItem['filters'] && Array.isArray(filterItem['filters'])) {
              this.ss.remove(`hidden${this.gridConfig.gridName}Columns`);
              this.ss.remove(`${this.gridConfig.gridName}Filters`);
              return false;
            }
            return true;
          });
          if (this.sort.length) {
            this.ss.remove(`${this.gridConfig.gridName}Sort`);
            this.sort = [];
          }
          if (this.gridOrderFields.length) {
            this.ss.remove(`${this.gridConfig.gridName}Order`);
            this.gridOrderFields = [];
            this.setGridOrder();
          }

          this.state = {
            filter: this.filter,
            sort: this.sort,
            skip: this.skip,
            take: this.pageSize,
          };
          this.clearFilterSort = false;
        }
      }
    }

    let solutionSetup = null;
    if (this.gridConfig.gridName === 'CaseExplorer') {
      solutionSetup = this.filter.filters.find(
        filter => filter['field'] === 'solutionId'
      )
        ? this.filter.filters.find(filter => filter['field'] === 'solutionId')[
            'value'
          ]
        : null;
      if (solutionSetup === 'ALL') {
        this.allSolutionDisplay = true;
      } else {
        this.allSolutionDisplay = false;
      }
    }
    // solutionSetup is a CaseExplorer thing only for now.
    if (this.gridConfig.gridName === 'IWProductShelf') {
      setupParam = this.ss.get('globals').firmId;
    }
    this.getSetup(setupParam, solutionSetup).subscribe(
      resp => {
        this.gridData.headers = resp['headers'];
        this.filterConditionalHiddenCols();
        if (resp['dropdowns']) {
          this.dropdownOptions = resp['dropdowns'];
        }
        this.defaultView = resp['defaultview'];
        if (
          this.defaultView &&
          !skipDefault &&
          !this.ss.get(`${this.gridConfig.gridName}Filters`)?.filters?.length
        ) {
          this.defaultViewSet = true;
          this.defaultView.sort.forEach(col => {
            this.sort.push({
              field: Object.keys(col)[0],
              dir: (Object.values(col)[0] as string).toLowerCase() as
                'asc' | 'desc',
            });
          });
          this.filter = this.gridSrvc.parseDefaultView(
            this.defaultView,
            this.gridData.headers,
            this.filter
          );
        }

        if (this.gridConfig.gridName === 'CaseExplorer') {
          const solutions = this.gridSrvc.getSolutionOptions();

          const currentHiddenCols = this.ss.get('hiddenCaseExplorerColumns');
          if (currentHiddenCols) {
            const possibleHiddenCols = ['pp', 'aw', 'iw', 'li'];
            const colsToHide = possibleHiddenCols.filter(
              item => !solutions.find(jItem => jItem.value === item)
            );
            const getMapping = (key: string): string[] | undefined =>
              ({
                pp: ['productProfilerProducts', 'productProfilerScoreClass'],
                aw: ['annuityWizardProducts', 'annuityWizardScoreClass'],
                iw: ['investmentWizardProducts', 'investmentWizardScoreClass'],
                li: ['lifeWizardProducts', 'lifeWizardScoreClass'],
              })[key];
            colsToHide.forEach(col => {
              getMapping(col).forEach(colToCheck => {
                if (!currentHiddenCols.includes(colToCheck))
                  currentHiddenCols.push(colToCheck);
              });
            });
            this.hidden = [...currentHiddenCols];

            // remove filters that don't have a matching grid column
            this.filter.filters = this.filter.filters.filter(filterItem => {
              return this.gridData.headers.some(
                headerItem => filterItem['field'] === headerItem.DataField
              );
            });

            this.ss.set('hiddenCaseExplorerColumns', [...currentHiddenCols]);
            currentHiddenCols.forEach(hiddenCol => {
              const foundHeader = this.gridData.headers.find(
                headerItem =>
                  headerItem.DataField === hiddenCol &&
                  appCols.includes(hiddenCol)
              );
              if (foundHeader) {
                this.gridData.headers.find(
                  headerItem => headerItem.DataField === hiddenCol
                ).Hidden = true;
                delete this.gridData.headers.find(
                  headerItem => headerItem.DataField === hiddenCol
                ).externalFilter;
              }
            });
          }
        }

        if (!autoUpdate) {
          this.updateExternalFilterOptions(this.gridData.headers);
          this.updateGridFilterCategories(this.gridData.headers);
        }
        if (this.groupBySelection) {
          const groupFilter =
            this.groupBySelection === 'review'
              ? 'group'
              : this.groupBySelection;

          this.filter.filters = this.filter.filters.filter(
            filter => filter['field'] !== 'group'
          );

          this.filter.filters.push({
            field: 'group',
            operator: 'equal',
            value: groupFilter,
          });
        }

        setTimeout(() => {
          if (!this.gridConfig.defaultEmptyGrid || fillEmptyGrid) {
            if (autoUpdate) {
              this.getGridData(false, true);
            } else {
              this.getGridData();
            }
          } else {
            this.hideGrid = false;
            this.loading = false;
            this.gridData.data = [];
            this.gridData.total = 0;
          }
          this.setColumnVisiblity();
          // request to remove sorting and col order user pref check on init. leaving these for reference
          // this.setSort();
          // this.setColOrder();
        }, 1000);
      },
      error => {
        console.error('GRID SETUP ERROR: ', error);
        this.loading = false;
      }
    );
  }

  gridHeight() {
    const { gridName } = this.gridConfig;
    return gridName === 'CopyCase' ? null : window.innerHeight - 210;
  }

  triggerGridSearch() {
    this.state.skip = 0;
    this.skip = 0;
    this.reportFilters = this.filter;
    if (this.gridConfig.gridName === 'RepBehavior') {
      this.getGridSetup(true, true);
    } else if (this.gridConfig.gridName === 'CaseExplorer') {
      this.getGridSetup(true);
    } else {
      this.getGridData();
    }
  }

  getGridData(gridFilter = false, autoUpdate = false) {
    this.showEmptyGridWarning = false;
    if (!this.loading && !this.gridConfig.simpleLoader) {
      this.loading = true;
    } else if (
      this.gridConfig.simpleLoader &&
      !this.simpleLoading &&
      !gridFilter
    ) {
      this.simpleLoading = true;
    }
    if (this.ss.get(`${this.gridConfig.gridName}Filters`)?.filters?.length) {
      this.filter = this.ss.get(`${this.gridConfig.gridName}Filters`);
    }
    if (this.ss.get(`${this.gridConfig.gridName}Sort`)?.length) {
      this.sort = this.ss.get(`${this.gridConfig.gridName}Sort`);
    }
    if (this.ss.get(`${this.gridConfig.gridName}Order`)?.length) {
      this.gridOrderFields = this.ss.get(`${this.gridConfig.gridName}Order`);
      this.setGridOrder();
    }
    if (this.ss.get(`${this.gridConfig.gridName}GridNav`)) {
      this.state.skip =
        this.ss.get(`${this.gridConfig.gridName}GridNav`).skip * 1;
      this.skip = this.ss.get(`${this.gridConfig.gridName}GridNav`).skip * 1;
      this.state.take =
        this.ss.get(`${this.gridConfig.gridName}GridNav`).take * 1;
      this.pageSize = this.state.take;
    }
    this.cstmFltrSrvc.updateGroupByValue(this.groupBySelection);
    if (this.groupBySelection) {
      this.filter.filters = this.filter.filters.filter(
        filter => filter['field'] !== 'group'
      );
      this.filter.filters.push({
        field: 'group',
        operator: 'equal',
        value: this.groupBySelection,
      });
    }
    this.filter.filters = this.filter.filters.filter(
      filterItem =>
        (Object.prototype.hasOwnProperty.call(filterItem, 'value') &&
          filterItem['value'] !== null &&
          filterItem['value'] !== '') ||
        (Object.prototype.hasOwnProperty.call(filterItem, 'filters') &&
          filterItem['filters'] !== null)
    );
    this.reportFilters = this.filter;

    if (this.gridConfig.gridName === 'RepBehavior') {
      this.getScoreClassChanges();
    }

    this.getData(JSON.stringify(this.generateQueryData())).subscribe(
      resp => {
        if (resp['data']) {
          if (this.gridConfig.gridName === 'CopyCase') {
            const currentNewCase = resp['data'].find(
              datapoint => datapoint.profileId === this.gridConfig.profileId
            );
            if (currentNewCase) {
              currentNewCase['disableCopy'] = true;
            }
          }

          this.gridData.data = resp['data'];
          this.gridData.total = resp['total'];
        }
        if (resp['dropdowns']) {
          this.dropdownOptions = resp['dropdowns'];
        }
        this.ogData = this.gridData.data;
        this.state.take = this.pageSize;
        if (this.gridConfig.gridName === 'CaseSearch') {
          this.unfFlowSvc.getAllApps().subscribe(x => {
            x.Modules.map(module => {
              if (module.name === 'SummaryPage') {
                this.showSummaryLink = true;
              }
            });
          });
        }

        setTimeout(() => {
          if (resp['dropdowns']) {
            this.buildFilterOptions(resp['dropdowns']);
            this.updateExternalFilterOptions(
              this.gridData.headers,
              resp['dropdowns']
            );
            this.updateGridFilterCategories(this.gridData.headers);
          } else {
            this.buildFilterOptions(this.dropdownOptions);
          }

          if (this.pageChangeData) {
            this.state.skip = this.pageChangeData.skip;
            this.state.take = this.pageChangeData.take;
            this.skip = this.pageChangeData.skip;
            this.pageChangeData = null;
          }

          this.hideGrid = false;
          this.loading = false;
          this.simpleLoading = false;
          if (
            (this.pageSelector &&
              this.pageSelector.checked &&
              !this.pagesSelected.includes(this.state.skip)) ||
            (this.pageSelector &&
              !this.pageSelector.checked &&
              this.pagesSelected.includes(this.state.skip))
          ) {
            this.pageSelector.toggle();
          }

          if (this.gridConfig.groupByOptions && !autoUpdate) {
            this.cstmFltrSrvc.reloadFilterValues(true);
          }

          this.cdRef.detectChanges();
        }, 1000);
        this.lastFilter = cloneDeep(this.filter);
      },
      error => {
        this.hideGrid = false;
        this.loading = false;
        this.simpleLoading = false;
        this.snacky.open(
          `Whoops! Something went wrong, please try again later`,
          'Close',
          {
            duration: 4000,
          }
        );
        console.error('DATA ERROR: ', error);
      }
    );
  }

  generateQueryData(altFilters?, payloadOverride?) {
    this.gridSrvc.destroyGridSelections();
    let queryFilters = this.filter;
    let queryData: any = {
      take: this.state.take,
      skip: this.state.skip,
      search: {},
      sort: {},
    };

    if (
      payloadOverride &&
      Object.prototype.hasOwnProperty.call(payloadOverride, 'take') &&
      Object.prototype.hasOwnProperty.call(payloadOverride, 'skip')
    ) {
      queryData.take = payloadOverride.take;
      queryData.skip = payloadOverride.skip;
    }

    if (altFilters) {
      queryFilters = altFilters;
    }

    // This map parses and formats filters
    queryFilters.filters.map(filter => {
      if (filter['filters']) {
        filter['filters'].map(nextFilter => {
          // This should fire if filters are nested
          queryData = this.parseFilters(nextFilter, queryData);
        });
      } else {
        // This should fire on regular filter parsing
        queryData = this.parseFilters(filter, queryData);
      }
    });

    // This map parses and formats sorts
    this.sort.map(sortItem => {
      if (sortItem.dir !== undefined) {
        queryData.sort[sortItem.field] = sortItem.dir.toUpperCase();
      } else {
        delete queryData.sort[sortItem.field];
      }
    });

    if (this.gridConfig.gridName === 'CaseManagement') {
      if (this.groupBySelection === 'GROUP') {
        queryData['group'] = 'CRID';
      }
      if (this.groupBySelection === 'FLAT') {
        queryData['group'] = 'Source';
      }
    } else if (this.gridConfig.gridName === 'CaseExplorer') {
      if (this.gridConfig.groupByOptions) {
        queryData['group'] = this.groupBySelection;
      }
    } else if (this.gridConfig.gridName === 'RepBehavior') {
      if (isEmpty(queryData.search)) {
        delete queryData.search;
      }
      if (isEmpty(queryData.sort)) {
        queryData.sort = {};
      }
      if (this.gridConfig.groupByOptions) {
        queryData['group'] = this.groupBySelection;
      }
    } else if (this.gridConfig.gridName === 'BookManagement') {
      if (this.bridgeIdSearch) {
        queryData['search']['bridgeid'] = {
          selected: [`${this.bridgeIdSearch}`],
        };
      }
    } else if (this.gridConfig.gridName === 'IWProductShelf') {
      if (!queryData.search['ProgramName']) {
        queryData.search['ProgramName'] = {
          searchString: this.gridConfig.initialProgram,
        };
      }
      if (!queryData.search['FirmID']) {
        queryData.search['FirmID'] = {
          selected: [this.ss.get('globals').firmId],
        };
      }
    } else {
      if (
        isEmpty(queryData.sort) &&
        this.gridConfig.gridName === 'TradeReviewGrid'
      ) {
        queryData.sort['TradeDate'] = 'DESC';
      } else if (
        isEmpty(queryData.sort) &&
        ['AccountReviewGrid', 'RepReviewGrid', 'AmlMonitorGrid'].includes(
          this.gridConfig.gridName
        )
      ) {
        queryData.sort['ProcessedDate'] = 'DESC';
      } else if (isEmpty(queryData.sort) && this.gridConfig.rowSelector) {
        queryData.sort[this.gridConfig.rowSelector] = 'ASC';
      }
    }

    if (this.groupBySelection) {
      delete queryData.search['group'];
    }

    return queryData;
  }

  parseFilters(filter, queryData) {
    let parsedQuery = queryData;

    if (filter['field'] && this.dropdownFilters.includes(filter['field'])) {
      parsedQuery['search'][filter['field']] =
        this.gridSrvc.generateDropdownQuery(
          filter,
          this.dropdownFilters,
          this.dropdownOptions
        );
    }

    if (filter['field'] && this.searchFilters.includes(filter['field'])) {
      parsedQuery['search'][filter['field']] =
        this.gridSrvc.generateSearchStringQuery(filter, this.searchFilters);
    }

    if (filter['field'] && this.equalSearchFilters.includes(filter['field'])) {
      parsedQuery['search'][filter['field']] =
        this.gridSrvc.generateEqualSearchStringQuery(
          filter,
          this.equalSearchFilters
        );
    }

    if (filter['field'] && this.dateFilters.includes(filter['field'])) {
      parsedQuery.search[filter['field']] = this.gridSrvc.generateDateQuery(
        filter,
        this.dateFilters
      );
    }

    if (filter['field'] && this.presetDateFilters.includes(filter['field'])) {
      parsedQuery.search[filter['field']] =
        this.gridSrvc.generatePresetDateQuery(
          filter,
          this.presetDateFilters,
          this.filter.filters,
          this.gridConfig.gridName
        );
    }

    if (filter['field'] && this.valueRangeFilters.includes(filter['field'])) {
      parsedQuery = this.gridSrvc.generateValueRangeQuery(
        parsedQuery,
        filter,
        this.valueRangeFilters
      );
    }

    parsedQuery = this.gridSrvc.generateExceptionsQuery(
      parsedQuery,
      filter,
      this.valueRangeFilters,
      this.gridConfig.gridName
    );

    return parsedQuery;
  }

  updateExternalFilterOptions(headers, newOptions?) {
    this.externalFilters = [];
    this.dropdownFilters = [];
    this.searchFilters = [];
    this.equalSearchFilters = [];
    this.presetDateFilters = [];
    this.dateFilters = [];
    this.valueRangeFilters = [];
    headers
      .filter(x => x.externalFilter)
      .forEach(el => {
        const entry = el.externalFilter;
        if (
          (Object.keys(entry).includes('right') &&
            this.rights?.includes(entry['right'])) ||
          !Object.keys(entry).includes('right')
        ) {
          entry.varName = el.DataField;
          entry.fullField = el;
          this.externalFilters.push(entry);
          if (
            el.Type &&
            el.Type.toLowerCase() === 'curr' &&
            entry &&
            !['currencyRange', 'valueRange'].includes(entry.controlType)
          ) {
            entry.controlType = 'currency';
          }
          if (
            el.FilterType === 'Dropdown' ||
            ['user', 'repCodeMulti', 'unitMulti'].includes(entry.controlType)
          ) {
            this.dropdownFilters.push(entry.fullField.DataField);
          } else if (
            el.FilterType === 'SearchEquals' ||
            (entry.controlType === 'text' && entry.filterType === 'equals')
          ) {
            this.equalSearchFilters.push(entry.fullField.DataField);
          } else if (
            el.FilterType === 'Search' ||
            (entry.controlType === 'text' && entry.filterType === 'contains')
          ) {
            this.searchFilters.push(entry.fullField.DataField);
          } else if (
            el.FilterType === 'Range' ||
            entry.controlType === 'presetRange'
          ) {
            this.presetDateFilters.push(entry.fullField.DataField);
          } else if (
            el.FilterType === 'Range' ||
            el.externalFilter.controlType === 'range'
          ) {
            this.dateFilters.push(entry.fullField.DataField);
          } else if (entry.controlType === 'relatedDate') {
            this.dateFilters.push(entry.fullField.DataField);
            this.dateFilters.push(entry.relatedVarName);
          } else if (
            ['currencyRange', 'valueRange'].includes(entry.controlType)
          ) {
            this.valueRangeFilters.push(entry.fullField.DataField);
          }

          const entryIdx = this.externalFilters.findIndex(x => {
            return x.varName === el.DataField;
          });
          if (entryIdx > -1) {
            this.externalFilters[entryIdx].options =
              this.buildDropdownFilterOptions(el, newOptions);
            this.ogFilterData[el.DataField] =
              this.externalFilters[entryIdx].options;
            this.filterData[el.DataField] =
              this.externalFilters[entryIdx].options;
          }
        }
      });
    this.cstmFltrSrvc.reloadFilterValues(true);
  }

  updateGridFilterCategories(headers) {
    headers
      .filter(x => !x.externalFilter)
      .forEach(el => {
        if (
          el.FilterType === 'Dropdown' &&
          !this.dropdownFilters.includes(el.DataField)
        ) {
          this.dropdownFilters.push(el.DataField);
        } else if (
          el.FilterType === 'Search' &&
          !this.searchFilters.includes(el.DataField)
        ) {
          this.searchFilters.push(el.DataField);
        } else if (
          el.FilterType === 'Range' &&
          !this.dateFilters.includes(el.DataField)
        ) {
          this.dateFilters.push(el.DataField);
        }
      });
  }

  buildDropdownFilterOptions(el, newOptions?) {
    let options;
    options = [];
    options = this.filterOptions[el.DataField]
      ? this.filterOptions[el.DataField].map(x => {
          return { value: x, display: x };
        })
      : [];
    options = this.gridSrvc.deDupObjectArray(options);
    options = this.clearEmptyFields(options);
    options = options.sort((a, b) => (a.display > b.display ? 1 : -1));

    if (el.Validation) {
      options = el.Validation.map(x => {
        const label = x.label ? x.label : x.value;

        return { value: x.value, display: label };
      });
    } else if (!el.Validation && newOptions && newOptions[el.DataField]) {
      options = newOptions[el.DataField].map(option => {
        return { value: option, display: option };
      });
    } else if (
      !el.Validation &&
      el.externalFilter.options &&
      el.externalFilter.options?.length > 0
    ) {
      options = el.externalFilter.options.map(x => {
        const label = x.display ? x.display : x.value;

        return { value: x.value, display: label };
      });
    } else if (
      !el.Validation &&
      this.dropdownOptions &&
      this.dropdownOptions[el.DataField]
    ) {
      options = this.dropdownOptions[el.DataField].map(option => {
        return { value: option, display: option };
      });
    }

    return options;
  }

  buildFilterOptions(extendedOptions?) {
    this.filterData = this.cstmFltrSrvc.buildColumnFilterOptions(
      this.ogData,
      this.gridData.headers
    );
    this.ogFilterData = this.cstmFltrSrvc.buildColumnFilterOptions(
      this.ogData,
      this.gridData.headers
    );

    if (extendedOptions) {
      Object.keys(extendedOptions).map(fieldName => {
        const newOptions = [];
        extendedOptions[fieldName].map(option => {
          newOptions.push({
            display: option,
            value: option,
          });
        });

        this.filterData[fieldName] = newOptions;
        this.ogFilterData[fieldName] = newOptions;
      });
    }
    if (this.filterOptions) {
      for (const [key, value] of Object.entries(this.filterOptions)) {
        this.filterData[key] = value;
        this.ogFilterData[key] = value;
      }
    }
  }

  public onFilterChange(searchTerm, dataSet): void {
    if (!searchTerm) {
      this.filterData[dataSet] = this.ogFilterData[dataSet];
    } else {
      this.filterData[dataSet] = this.filterData[dataSet].filter(dataPoint =>
        dataPoint.value.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  }

  filterValueChange(ev, dataField, filterData, service?) {
    if (service) {
      service.close();
    }
    //trigger header filter changes to update externals
    this.colFiltersChanged = {
      values: ev,
      dataField: dataField,
      filterData: filterData,
      currentFilters: this.state.filter,
    };
  }

  public multiselectFilterValueChange(
    values,
    field,
    filterService: FilterService,
    column,
    service
  ): void {
    if (!this.dropdownFilters.includes(field)) {
      this.dropdownFilters.push(field);
    }

    // Preserve existing filters for other fields
    const preservedFilters = this.state.filter.filters.filter(filterGroup => {
      if (filterGroup['filters']) {
        return !filterGroup['filters'].some(
          subFilter => subFilter.field === field
        );
      } else {
        return filterGroup['field'] !== field;
      }
    });

    // Add new filters for the triggered field based on `values`
    if (values.length > 0) {
      values = values.flat();
      values = Array.from(new Set(values));
      const newFilterGroup = {
        filters: values.map(value => ({
          field: field,
          operator: 'contains',
          value,
        })),
        logic: 'or' as const,
      };

      preservedFilters.push(newFilterGroup);
    }

    this.state.filter = {
      ...this.state.filter,
      filters: preservedFilters,
    };

    const filterToPush: CompositeFilterDescriptor = {
      logic: 'and',
      filters: preservedFilters,
    };

    filterService.filter(filterToPush);

    this.filterValueChange(values, field, column, service);
    this.rbGrid.dataStateChange.emit();
  }

  public searchFilterValueChange(
    values,
    field,
    filterService: FilterService,
    column
  ): void {
    if (!this.searchFilters.includes(field)) {
      this.searchFilters.push(field);
    }

    filterService.filter({
      filters: [
        {
          field: field,
          operator: 'contains',
          value: values,
        },
      ],
      logic: 'or',
    });
    this.filterValueChange(values, field, column);
  }

  public commaSelectFilterValueChange(
    values,
    field,
    filterService: FilterService,
    column
  ): void {
    if (!this.dropdownFilters.includes(field)) {
      this.dropdownFilters.push(field);
    }

    const valuesToAdd = values.replaceAll(' ', '').split(',');

    filterService.filter({
      filters: valuesToAdd.map(value => ({
        field: field,
        operator: 'contains',
        value: value,
      })),
      logic: 'or',
    });
    this.filterValueChange(valuesToAdd, field, column);
  }

  getTextboxValue(dataField) {
    const textVal = this.filter?.filters.find(filterField => {
      if (Object.prototype.hasOwnProperty.call(filterField, 'filters')) {
        return filterField['filters'].find(
          subItem => subItem?.field === dataField
        )?.value;
      }
    })?.['filters'][0]?.value;
    return textVal ? textVal : null;
  }

  public dateFilterValueChange(field): void {
    if (!this.dateFilters.includes(field)) {
      this.dateFilters.push(field);
    }
  }

  public valueRangeFilterValueChange(field): void {
    if (!this.valueRangeFilters.includes(field)) {
      this.valueRangeFilters.push(field);
    }
  }

  public pageChangeEvent(ev) {
    this.pageChangeData = ev;
  }

  public dataStateChange(state = this.state): void {
    if (this.pageSelector?.checked) {
      this.pageSelector.toggle();
    }
    this.selectedTradeList = [];
    this.selectedChecked = {};
    this.bulkSelectControl = false;
    this.pageSelectControl = false;
    this.pagesSelected = [];
    this.bulkActionControl.setValue(null);
    this.skip = state.skip;
    this.pageSize = state.take;
    this.state = state;
    this.filter = { ...this.state.filter };
    this.sort = this.state.sort;
    this.setStorage();
    this.getGridData();
  }

  updateFilters(ev) {
    this.resetFilters = false;
    // Took these out to fix #26262 page numbers were getting reset to 1 on pager after page refresh.
    // Looks like this was done for #25210. May need to reworked on page reload to not clear them out.
    // this.skip = 0;
    // this.state.skip = 0;
    let firstUpdate = false;
    if (ev.additionalData?.firstUpdate) {
      firstUpdate = true;
      delete ev.additionalData;
    }
    this.filter = ev;

    if (this.gridConfig.gridName === 'IWProductShelf') {
      this.filter.filters = this.gridSrvc.flattenAndRemoveDuplicates(
        this.filter
      );
    }

    if (
      this.ptGrids.includes(this.gridConfig.gridName) &&
      this.filter.filters.filter(
        filterObj => filterObj['field'] === 'ProcessedDate'
      ).length > 1
    ) {
      const start = DateTime.fromISO(
        this.filter.filters.find(
          filterObj =>
            filterObj['field'] === 'ProcessedDate' &&
            filterObj['operator'] === 'start'
        )['value'],
        {
          zone: 'utc',
        }
      );
      const end = DateTime.fromISO(
        this.filter.filters.find(
          filterObj =>
            filterObj['field'] === 'ProcessedDate' &&
            filterObj['operator'] === 'end'
        )['value'],
        {
          zone: 'utc',
        }
      );

      const { days } = end.diff(start, 'days').toObject();

      if (Math.trunc(days) > 30) {
        this.showPtDateWarning = true;
      }
    }

    this.state = {
      filter: this.filter,
      sort: this.sort,
      skip: this.state.skip,
      take: this.pageSize,
    };
    if (!this.gridConfig.manualSearch && !firstUpdate) {
      this.state.skip = 0;
      this.skip = 0;
    }
    this.setStorage();

    if (!this.gridConfig.manualSearch && !firstUpdate) {
      if (this.gridConfig.gridName === 'RepBehavior') {
        this.getGridSetup(true, true, true);
      } else if (this.gridConfig.gridName === 'CaseExplorer') {
        this.getGridSetup(true, false, true);
      } else {
        this.getGridData(false, true);
      }
    }
  }

  kendoToExternal(kendoFilter: any): any {
    const externalFilter: any = { logic: kendoFilter.logic, filters: [] };

    for (const kendoFilterItem of kendoFilter.filters) {
      if ('filters' in kendoFilterItem && kendoFilterItem.logic === 'or') {
        // Combine "contains" filters into a "selected" filter
        const field = kendoFilterItem.filters[0].field;
        const values = kendoFilterItem.filters.map(
          f => (f as any).value as string
        );
        externalFilter.filters.push({
          field: field,
          operator: 'selected',
          value: values,
        });
      } else {
        // Copy other filters as-is
        externalFilter.filters.push(kendoFilterItem as any);
      }
    }
    externalFilter.filters = this.gridSrvc.deDupObjectArray(
      externalFilter.filters
    );
    return externalFilter;
  }

  externalColumnsUpdated(ev) {
    // This is a hack to stop the grid from scrolling to the right
    const gridContentScroll = document.querySelector('.k-grid-content');
    const oldScrollPosition = gridContentScroll.scrollLeft;

    const headerWrapContentScroll = document.querySelector(
      '.k-grid-header-wrap'
    );
    const headerWrapPosition = headerWrapContentScroll.scrollLeft;
    setTimeout(() => {
      gridContentScroll.scrollLeft = oldScrollPosition;
      headerWrapContentScroll.scrollLeft = headerWrapPosition;
    });

    const fullList = this.gridData.headers.map(x => {
      return x.DataField;
    });
    if (this.hiddenExtColsShowing) {
      ev = [
        ...ev,
        ...this.gridData.headers
          .filter(filterItem => filterItem.HiddenExt)
          .map(x => x.DataField),
      ];
    }
    const hidden = fullList.filter(y => !ev.includes(y));

    this.hidden = [...hidden];
    this.setStorage();
    // request to remove sorting and col order user pref check on init. leaving these for reference
    if (!noColSaveGrids.includes(this.gridConfig.gridName)) {
      this.saveUserDefinedColumns();
      // this.saveUserDefinedSort();
      // this.saveUserDefinedOrder();
    }
  }

  setSort() {
    const columnsSort = this.ss.get(`${this.gridConfig.gridName}Sort`);

    if (
      !columnsSort?.length &&
      !noColSaveGrids.includes(this.gridConfig.gridName)
    ) {
      this.prefSrvc.getSort().subscribe(x => {
        if (
          x &&
          Object.prototype.hasOwnProperty.call(
            x,
            `${this.gridConfig.gridName}Sort`
          ) &&
          x[`${this.gridConfig.gridName}Sort`].length > 0
        ) {
          this.state.sort = x[`${this.gridConfig.gridName}Sort`];
          this.sort = x[`${this.gridConfig.gridName}Sort`];
        }
      });
    }
  }

  setColOrder() {
    if (
      !this.gridOrderFields?.length &&
      !noColSaveGrids.includes(this.gridConfig.gridName)
    ) {
      this.prefSrvc.getColOrder().subscribe(x => {
        if (
          x &&
          Object.prototype.hasOwnProperty.call(
            x,
            `${this.gridConfig.gridName}Order`
          ) &&
          x[`${this.gridConfig.gridName}Order`].length > 0
        ) {
          this.gridOrderFields = x[`${this.gridConfig.gridName}Order`];
          this.setGridOrder();
        }
      });
    }
  }

  setColumnVisiblity() {
    const hiddenColumns = this.ss.get(
      `hidden${this.gridConfig.gridName}Columns`
    );

    if (
      !hiddenColumns?.length &&
      !noColSaveGrids.includes(this.gridConfig.gridName)
    ) {
      this.prefSrvc.getColumns().subscribe(x => {
        const fullList = this.gridData.headers.map(x => {
          return x.DataField;
        });
        this.loadedUserPrefs =
          x &&
          Object.prototype.hasOwnProperty.call(x, this.gridConfig.gridName) &&
          x[`${this.gridConfig.gridName}`].length > 0;
        if (!this.loadedUserPrefs) {
          this.checkAndSetHiddenCols(hiddenColumns);
        } else {
          const hidden = fullList.filter(
            y => !x[`${this.gridConfig.gridName}`].includes(y)
          );

          this.checkAndSetHiddenCols(hidden);
        }
      });
    } else {
      this.checkAndSetHiddenCols(hiddenColumns);
    }
  }

  checkAndSetHiddenCols(hiddenColumns) {
    this.ogHidden = [];
    this.hidden = [];
    let subCount = 0;
    this.gridData['subHead'] = [];
    this.gridData.headers.forEach(x => {
      if (x.subgroup) {
        if (subCount < 1) {
          this.gridData['subHead'] = [];
        }

        this.gridData['subHead'].push(x);
        this.gridData.headers = this.gridData.headers.filter(z => z !== x);

        subCount++;
        this.gridData.headers = this.gridData.headers.filter(z => z !== x);
      }

      if (
        (hiddenColumns && hiddenColumns.includes(x.DataField)) ||
        (!hiddenColumns && x.Hidden)
      ) {
        x.Hidden = true;
        this.hidden.push(x.DataField);
        this.ogHidden.push(x.DataField);
      } else {
        x.Hidden = false;
      }
    });
    this.setStorage();
  }

  setStorage() {
    if (!noColSaveGrids.includes(this.gridConfig.gridName))
      this.ss.set(`hidden${this.gridConfig.gridName}Columns`, this.hidden);
    if (!noFilterSaveGrids.includes(this.gridConfig.gridName)) {
      this.ss.set(`${this.gridConfig.gridName}Filters`, this.filter);
      this.ss.set(`${this.gridConfig.gridName}Sort`, this.sort);
      this.ss.set(`${this.gridConfig.gridName}Order`, this.gridOrderFields);
    }
    if (this.gridConfig.storeGridNav) {
      this.ss.set(`${this.gridConfig.gridName}GridNav`, {
        skip: this.state.skip,
        take: this.state.take,
      });
    }
  }

  isHidden(columnName: string): boolean {
    return this.hidden.indexOf(columnName) > -1;
  }

  saveUserDefinedColumns(reset = false) {
    const fullList = this.gridData.headers.map(x => {
      return x.DataField;
    });
    let visible = fullList.filter(x => !this.hidden.includes(x));
    if (reset) {
      visible = [];
    }

    this.prefSrvc
      .saveColumns({
        [`${this.gridConfig.gridName}`]: visible,
      })
      .subscribe();
  }

  saveUserDefinedSort(reset = false) {
    let sorted = this.state.sort;
    if (reset) {
      sorted = [];
    }

    this.prefSrvc
      .saveSort({
        [`${this.gridConfig.gridName}Sort`]: sorted,
      })
      .subscribe();
  }

  saveUserDefinedOrder(reset = false) {
    let ordered = this.gridOrderFields;
    if (reset) {
      ordered = [];
    }

    this.prefSrvc
      .saveColOrder({
        [`${this.gridConfig.gridName}Order`]: ordered,
      })
      .subscribe();
  }

  clearEmptyFields(data) {
    const updated = data.filter(item => {
      if (typeof item.value === 'string' && item.value?.length < 1) {
        return false;
      }

      return item;
    });

    return updated;
  }

  headerFilterValueChange(ev, dataField, filterData) {
    //trigger header filter changes to update externals
    this.colFiltersChanged = {
      values: ev,
      dataField: dataField,
      filterData: filterData,
      currentFilters: this.kendoToExternal(this.state.filter),
    };
  }

  reset() {
    if (this.gridConfig.gridName === 'CaseManagement') {
      this.hideGrid = true;
    }
    if (this.ptGrids.includes(this.gridConfig.gridName)) {
      this.showPtDateWarning = false;
    }
    this.sort = [];
    this.filter = { logic: 'and', filters: [] };
    this.gridOrderFields = [];
    this.skip = 0;
    this.buildFilterOptions();
    this.externalFilters = [];
    this.showEmptyGridWarning = true;
    this.reportFilters = { logic: 'and', filters: [] };

    this.ss.remove(`${this.gridConfig.gridName}GridNav`);
    this.ss.remove(`hidden${this.gridConfig.gridName}Columns`);
    this.ss.remove(`${this.gridConfig.gridName}Filters`);
    this.ss.remove(`${this.gridConfig.gridName}Sort`);
    this.ss.remove(`${this.gridConfig.gridName}Order`);
    this.state = {
      filter: this.filter,
      sort: this.sort,
      skip: this.skip,
      take: this.pageSize,
    };

    this.resetFilters = true;

    if (this.gridConfig.additionalResetFunc) {
      this.gridConfig.additionalResetFunc();
    }

    if (!noColSaveGrids.includes(this.gridConfig.gridName)) {
      this.saveUserDefinedColumns(true);
      // the following saved data is never used later on so removing for now.
      // this.saveUserDefinedSort(true);
      // this.saveUserDefinedOrder(true);
    }

    if (this.gridConfig.gridName === 'CaseManagement') {
      this.getGridSetup(true);
    } else {
      this.getGridSetup();
    }
  }

  viewRecord(ev) {
    this.route.navigate([
      `${this.gridConfig.detailViewRoute}${ev[this.gridConfig.rowSelector]}`,
    ]);
  }

  bulkSelect({ checked, reset }) {
    this.selectedTradeList = [];
    this.selectedChecked = {};
    if (checked) {
      this.bulkSelectControl = true;
    } else {
      this.bulkSelectControl = false;
    }
  }

  pageSelect({ checked }) {
    if (checked) {
      this.pagesSelected.push(this.skip);
      this.gridData.data.map(dataObj => {
        this.selectedTradeList.push(dataObj);
        this.selectedChecked[dataObj[this.gridConfig.rowSelector]] = true;
      });
    } else {
      this.pagesSelected = this.pagesSelected.filter(
        page => page !== this.state.skip
      );
      this.gridData.data.map(dataObj => {
        this.selectedTradeList = this.selectedTradeList.filter(x => {
          return x !== dataObj;
        });
        this.selectedChecked[dataObj[this.gridConfig.rowSelector]] = false;
      });
    }
  }

  resetSelect() {
    this.selectedChecked = {};
    this.bulkSelectControl = false;
  }

  toggleRowSelect(item) {
    const indexExisting = this.selectedTradeList.findIndex(x => x === item);
    if (indexExisting > -1) {
      if (this.pageSelector && this.pageSelector.checked) {
        this.pageSelector.toggle();

        this.pagesSelected = this.pagesSelected.filter(
          page => page !== this.state.skip
        );
      }

      this.selectedTradeList = this.selectedTradeList.filter(x => {
        return x !== item;
      });
      this.selectedChecked[item[this.gridConfig.rowSelector]] = false;
    } else {
      if (
        this.pageSelector &&
        !this.pageSelector.checked &&
        this.rowsAreSelected()
      ) {
        this.pageSelector.toggle();
        this.pagesSelected.push(this.state.skip);
      }

      this.selectedTradeList.push(item);
      this.selectedChecked[item[this.gridConfig.rowSelector]] = true;
    }
  }

  rowsAreSelected() {
    return every(this.gridData.data, dataPoint => {
      return some(this.selectedTradeList, selectedObj => {
        return isEqual(dataPoint, selectedObj);
      });
    });
  }

  resetBulkAction(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    this.bulkActionControl.setValue('');
  }

  displayValue(datafield, value) {
    const hasDisplayValue =
      datafield.Validation &&
      datafield.Validation.find(valOption => valOption.value === value);
    if (hasDisplayValue) {
      return datafield.Validation.find(valOption => valOption.value === value)
        .label;
    } else {
      return value;
    }
  }

  setBridgeIdSearch(e) {
    if (e === 'clear') {
      this.bridgeIdSearch = null;
    } else {
      this.bridgeIdSearch = e.value;
    }
  }

  getDownloadData = () => {
    const { downloadGridButtonProps } = this.gridConfig;
    const payloadOverride = downloadGridButtonProps?.payloadOverride
      ? downloadGridButtonProps?.payloadOverride
      : null;

    return this.getData(
      this.generateQueryData(null, payloadOverride),
      this.gridConfig.downloadGridButtonProps?.action
    );
  };

  getDownloadQuery = () => {
    return this.generateQueryData(this.reportFilters);
  };

  deleteRow(item) {
    this.deleteItem.emit(item);
  }

  checkRowClass(row: RowClassArgs) {
    let returnClass = '';
    if (row.dataItem.PastSLA) {
      returnClass += 'past-sla ';
    }
    if (row.dataItem.disableCopy) {
      returnClass += 'disable-copy ';
    }
    if (row.dataItem.NewUpdate) {
      returnClass += 'update-available ';
    }
    return returnClass;
  }

  changeGroupBySelection(): void {
    this.filter.filters.find(filterItem => filterItem['field'] === 'group')[
      'value'
    ] = this.groupBySelection;
    this.setStorage();

    this.cstmFltrSrvc.updateGroupByValue(this.groupBySelection);
    this.clearFilterSort = true;
    if (this.gridConfig.gridName === 'CaseManagement') {
      this.reset();
    } else if (this.gridConfig.gridName === 'RepBehavior') {
      this.clearAdditionalFilters();
      this.getGridSetup(true, true);
    } else {
      this.getGridSetup(true);
    }
  }

  clearAdditionalFilters() {
    const filtersToClear = [];

    this.gridData.headers
      .filter(
        header =>
          header.externalFilter &&
          header.externalFilter.filterGroup === 'additional'
      )
      .map(header => {
        this.filter.filters.map(filter => {
          if (filter['field'] === header.DataField) {
            if (filter) {
              if (this.valueRangeFilters.includes(header.DataField)) {
                filter['value'] = '';
                this.cstmFltrSrvc.updateValueRanges(filter);
              } else if (
                [
                  'chip',
                  'repCode',
                  'repCodeMulti',
                  'unitMulti',
                  'user',
                ].includes(header.externalFilter.controlType)
              ) {
                filter['value'] = [];
                this.cstmFltrSrvc.updateDropdownValues(
                  filter,
                  header.DataField
                );
              }
            }
          }
        });

        filtersToClear.push(header.DataField);
      });
    this.filter.filters = this.filter.filters.filter(
      filter => !filtersToClear.includes(filter['field'])
    );
  }

  disableSearch(nonEqualFlag?) {
    if (this.loading || this.simpleLoading) {
      return true;
    } else {
      const disableData = {
        gridName: this.gridConfig.gridName,
        conditionalSearch: this.gridConfig.conditionalSearch,
        headers: this.gridData.headers,
        lastFilter: this.lastFilter,
      };

      return this.gridSrvc.disableSearch(
        this.filter,
        disableData,
        nonEqualFlag
      );
    }
  }

  deleteProfile(id) {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Warning',
        content: 'Are you sure you want to delete this profile?',
        confirm: 'Yes',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.loading = true;
        this.rbs.deleteProfile(id).subscribe(() => {
          this.getGridData();
          this.loading = false;
        });
      }
      dialogRef = null;
    });
  }

  handleAdditionalData(ev) {
    // function for data from filters that need to pass data back up.
    // add to this as necessary

    this.repBehaviorReport = ev.repBehaviorReport;
  }

  launchToAutoReports(ev): void {
    this.route.navigate([`/automated-reports`]);
  }

  getScoreClassChanges() {
    this.loadingBenchmarks = true;
    const queryData = this.generateQueryData();

    queryData['search']['name']['selected'][0] =
      queryData['search']['name']['selected'][0] + '-Benchmark';

    this.getData(JSON.stringify(queryData)).subscribe({
      next: resp => {
        this.benchmarkData = resp.data;
        this.loadingBenchmarks = false;
      },
      error: err => {
        console.warn(`Error: ${err}`);
        this.benchmarkData = [];
        this.loadingBenchmarks = false;
      },
    });
  }

  viewHiddenValues(columnData, dataItem) {
    this.dialog.open(AlertsDialogComponent, {
      panelClass: 'app-alerts-dialog',
      data: {
        column: columnData,
        dataItem: dataItem,
      },
      minWidth: '300px',
    });
  }

  hiddenExtColsShow(): void {
    if (this.hiddenExtCols.length) {
      this.hiddenExtCols.forEach(hiddenExtCol => {
        if (
          !this.gridData.headers.find(
            header => header.DataField === hiddenExtCol.DataField
          )
        ) {
          this.gridData.headers.push(hiddenExtCol);
        }
      });

      this.gridData.headers = [...this.gridData.headers];

      this.hiddenExtColsShowing = true;

      this.setColumnVisiblity();
    }
  }

  filterConditionalHiddenCols() {
    this.hiddenExtCols = this.gridData.headers.filter(
      header => header.HiddenExt
    );
    this.gridData.headers = this.gridData.headers.filter(
      header => !header.HiddenExt
    );
  }

  toggleGridLoading(ev: boolean) {
    this.loading = ev;
  }

  toggleFileLoading(ev: boolean) {
    this.fileLoading = ev;
  }

  emitHiddenCols(ev) {
    this.hidden = ev;
    ev.forEach(col => {
      this.gridData.headers.find(header => header.DataField === col).Hidden =
        true;
    });
    this.gridData.headers
      .filter(header => !ev.includes(header.DataField))
      .forEach(header => (header.Hidden = false));
    this.gridData.headers = [...this.gridData.headers];
    this.setStorage();
  }

  emitColSort(ev) {
    this.state.sort = [...ev];
    this.sort = [...ev];
    this.setStorage();
  }

  emitGridOrder(ev) {
    this.gridOrderFields = [...ev];
    this.setGridOrder();
    this.setStorage();
  }

  setGridOrder() {
    if (this.gridOrderFields.length) {
      const orderMap = new Map(
        this.gridOrderFields.map((field, i) => [field, i])
      );
      this.gridData.headers.sort((a, b) => {
        const aIdx = orderMap.has(a.DataField)
          ? orderMap.get(a.DataField)
          : Infinity;
        const bIdx = orderMap.has(b.DataField)
          ? orderMap.get(b.DataField)
          : Infinity;
        return aIdx! - bIdx!;
      });
    }
  }

  // Reorder gridData.headers to match the grid's visual column order, preserving non-visible columns in place
  columnReorderTrigger(ev, gridParam) {
    if (
      !this.gridData.headers.find(
        header => header.DataField === ev.column.field
      ) ||
      ev.newIndex === 0
    ) {
      ev.preventDefault();
      return;
    }
    const columns: ColumnBase[] = gridParam.columns.toArray();
    const orderedColumns: ColumnBase[] = columns.sort(
      (a, b) => a.orderIndex - b.orderIndex
    );

    const orderedFields: string[] = orderedColumns
      .map(col => col['field'])
      .filter(field => !!field);

    const fieldSet = new Set(orderedFields);

    // Group non-shared headers by their preceding shared header in original order
    const gaps = new Map<string | null, any[]>();
    let lastShared: string | null = null;
    gaps.set(null, []);

    for (const header of this.gridData.headers) {
      if (fieldSet.has(header.DataField)) {
        lastShared = header.DataField;
        gaps.set(lastShared, []);
      } else {
        gaps.get(lastShared)!.push(header);
      }
    }

    const reordered: any[] = [...gaps.get(null)!];
    for (const field of orderedFields) {
      const header = this.gridData.headers.find(h => h.DataField === field);
      if (header) {
        reordered.push(header);
        if (gaps.has(field)) {
          reordered.push(...gaps.get(field)!);
        }
      }
    }
    this.gridOrderFields = reordered.map(item => item.DataField);
    // the following saved data is not used later on so removing for now.
    // this.saveUserDefinedOrder();
    this.gridData.headers = reordered;
  }
}
